import moment from 'moment'

import { longDateShortMonthTime } from 'utils'

export const RegistrationDate: TAnt.TableColumnRender<string> = (createdAt) => (
  <>{moment(createdAt).format(longDateShortMonthTime).toLowerCase()}</>
)
